import { CSSObject, Modal, ModalProps } from '@mantine/core';
import React from 'react';

interface Props {
  open: boolean;
  onClose: () => void;
  children: any;
  style?: CSSObject;
  inner?: CSSObject;
  content?: CSSObject;
  overlayProps?: ModalProps['overlayProps'];
}

function ModalComponent({ onClose, open, children, style, inner, content, overlayProps }: Props) {
  return (
    <Modal
      styles={{
        body: style,
        inner,
        content,
      }}
      opened={open}
      onClose={onClose}
      centered
      withCloseButton={false}
      size="auto"
      lockScroll={false}
      overlayProps={overlayProps}
    >
      {children}
    </Modal>
  );
}

export default ModalComponent;
